import {PrimaryExperimentalRoleType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {WHITE} from 'ui-library/Colors';

export const PRIMARY_ROLE_TO_COLOR = {
  [PrimaryExperimentalRoleType.BLANK]: WHITE,
  [PrimaryExperimentalRoleType.CONTROL]: '#FFCB90',
  [PrimaryExperimentalRoleType.STANDARD]: '#D4E27E',
  [PrimaryExperimentalRoleType.SAMPLE]: '#8ACFCB',
};
export const PRIMARY_ROLE_TO_DISPLAY_TEXT = {
  [PrimaryExperimentalRoleType.BLANK]: {displayName: 'Blank', abbreviation: null},
  [PrimaryExperimentalRoleType.CONTROL]: {displayName: 'Control', abbreviation: 'C'},
  [PrimaryExperimentalRoleType.STANDARD]: {displayName: 'Standard', abbreviation: 'St'},
  [PrimaryExperimentalRoleType.SAMPLE]: {displayName: 'Sample', abbreviation: 'S'},
};

export interface ExperimentalRole {
  primaryRole: PrimaryExperimentalRoleType;
  subrole: string | null;
  group: number;
}

export const ORDERED_PRIMARY_EXPERIMENTAL_ROLES = [
  PrimaryExperimentalRoleType.SAMPLE,
  PrimaryExperimentalRoleType.CONTROL,
  PrimaryExperimentalRoleType.STANDARD,
  PrimaryExperimentalRoleType.BLANK,
];

export enum ControlSubrole {
  MAXIMUM = 'MAXIMUM',
  MINIMUM = 'MINIMUM',
  POSITIVE = 'POSITIVE',
  NEGATIVE = 'NEGATIVE',
}

export const EXPERIMENTAL_SUBROLE_TO_SYMBOL: {[group: string]: string} = {
  [ControlSubrole.MAXIMUM]: '>',
  [ControlSubrole.MINIMUM]: '<',
  [ControlSubrole.POSITIVE]: '+',
  [ControlSubrole.NEGATIVE]: '\u2013',
};

export type ExperimentalRolesByTypeMapping = {
  [role in PrimaryExperimentalRoleType]: null | {[subrole: string]: Array<ExperimentalRole>};
};

export const NULL_SUBROLE_KEY = 'NULL_SUBROLE_KEY';
